import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "searchBoxOverlayInner" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  class: "logo",
  "aria-label": "link to homepage"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    role: "img",
    "aria-hidden": "true",
    width: "108",
    height: "23",
    viewBox: "0 0 108 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M96.6831 16.1859V11.8308C96.6831 10.467 97.5412 9.5696 98.9932 9.5696C100.906 9.5696 101.633 10.7991 101.633 12.6927V15.286C101.633 17.2126 100.908 18.4446 98.9932 18.4446C97.5412 18.4446 96.6831 17.5472 96.6831 16.1834M97.2115 22.9975C98.9605 22.9975 100.576 22.2674 101.6 20.2394V22.5995H107.738V0H101.6V7.64554C100.677 5.71895 98.9277 5.05224 97.1461 5.05224C93.2204 5.05224 90.4473 7.94467 90.4473 13.0628V14.9894C90.4473 20.0746 93.384 23 97.2115 23",
      fill: "#0D058F"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M77.4145 16.1859V11.8308C77.4145 10.467 78.2726 9.5696 79.7246 9.5696C81.6371 9.5696 82.3644 10.7991 82.3644 12.6927V15.286C82.3644 17.2126 81.6396 18.4446 79.7246 18.4446C78.2726 18.4446 77.4145 17.5472 77.4145 16.1834M77.943 22.9975C79.6919 22.9975 81.3075 22.2674 82.3317 20.2394V22.5995H88.4693V0H82.3317V7.64554C81.4081 5.71895 79.6592 5.05224 77.8775 5.05224C73.9519 5.05224 71.1787 7.94467 71.1787 13.0628V14.9894C71.1787 20.0746 74.1154 23 77.943 23",
      fill: "#0D058F"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M58.7402 12.3961V11.7978C58.7402 10.4695 59.3014 9.57211 60.9849 9.57211C62.4369 9.57211 63.1943 10.4695 63.1943 11.7978V12.3961H58.7402ZM60.9849 22.9974C65.7687 22.9974 68.4739 20.5715 69.1332 16.9819H63.1943C62.8974 18.0111 62.1726 18.4775 60.9849 18.4775C59.3014 18.4775 58.7402 17.5802 58.7402 16.2518V15.6536H69.264V13.6915C69.264 7.57707 65.7662 5.04968 60.9824 5.04968C56.1986 5.04968 52.668 7.64298 52.668 13.0603V14.9869C52.668 20.4041 56.2967 22.9974 60.9824 22.9974",
      fill: "#0D058F"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M40 22.602H46.1377V11.301H51.4172V5.65051H40V22.602Z",
      fill: "#0D058F"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M26.8697 22.602V12.6623C26.8697 10.9005 27.6951 9.70396 29.3761 9.70396C30.7626 9.70396 31.2231 10.5684 31.2231 11.9652V22.602H37.3608V11.666C37.3608 8.50744 36.4373 5.05224 31.817 5.05224C29.7057 5.05224 27.9241 5.91668 26.8671 7.77736V0H20.7295V22.602H26.8671H26.8697Z",
      fill: "#0D058F"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0.738281 11.301H6.34748V16.9515H12.4851V11.301H18.0943V5.6505H12.4851V0H6.34748V5.6505H0.738281V11.301Z",
      fill: "#0D058F"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M18.0945 16.9515H12.4854V22.602H18.0945V16.9515Z",
      fill: "#0D058F"
    })
  ])
], -1)
const _hoisted_3 = { class: "search" }
const _hoisted_4 = { class: "searchBoxTitle" }
const _hoisted_5 = { class: "searchInputInner" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "globalSearchFilterInput srOnly" }, "Search", -1)
const _hoisted_7 = ["disabled", "aria-label"]
const _hoisted_8 = ["disabled", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("Web.Components.SearchBoxCTA")), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["searchInputWrapper", _ctx.keywordError && 'searchError'])
      }, null, 2),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          id: "globalSearchFilterInput",
          onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.trySearch && _ctx.trySearch(...args)), ["prevent"]), ["enter"])),
          type: "search",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.keyword) = $event)),
          autocomplete: "off"
        }, null, 544), [
          [_vModelText, _ctx.keyword]
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "searchInputButton",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.trySearch && _ctx.trySearch(...args))),
          disabled: !_ctx.keywordLengthOK(),
          "aria-label": _ctx.$t('Web.Containers.SubmitSearch')
        }, null, 8, _hoisted_7)
      ]),
      _createElementVNode("button", {
        type: "submit",
        class: "searchButton",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.trySearch && _ctx.trySearch(...args))),
        disabled: !_ctx.keywordLengthOK(),
        "aria-label": _ctx.$t('Web.Containers.SubmitSearch')
      }, _toDisplayString(_ctx.$t("Web.Containers.Search")), 9, _hoisted_8)
    ])
  ]))
}